var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        width: "178",
        height: "134",
        viewBox: "0 0 178 134",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
      },
    },
    [
      _c("path", {
        attrs: { d: "M177.151 133.108V0H0V133.108H177.151Z", fill: "#415CC6" },
      }),
      _c("path", {
        attrs: {
          d: "M27.8791 46.2747L68.046 8.37752C79.8851 -2.7925 99.0795 -2.7925 110.918 8.37752L151.085 46.2747C162.924 57.4449 162.924 75.5549 151.085 86.7251L110.918 124.622C99.0795 135.793 79.8851 135.793 68.046 124.622L27.8791 86.7251C16.0403 75.5549 16.0403 57.4449 27.8791 46.2747Z",
          fill: "#5171EE",
        },
      }),
      _c("path", {
        attrs: {
          d: "M73.2983 52.8315C81.6955 45.0562 95.3104 45.0562 103.708 52.8315C112.105 60.6071 112.105 73.2135 103.708 80.9889C95.3104 88.7642 81.6958 88.7642 73.2983 80.9889C64.9006 73.2135 64.9006 60.6071 73.2983 52.8315Z",
          fill: "#7194FF",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }